import { useQuery } from '@tanstack/react-query';
import { api } from '../../../lib/api';

/** Kann der Server zuhören und vorlesen? Ohne Einrichtung fällt die Oberfläche auf den Browser zurück. */
export function useKianVoiceConfig() {
  return useQuery({
    queryKey: ['kian-voice-config'],
    queryFn: () => api.getKianVoiceConfig(),
    staleTime: 5 * 60_000,
    retry: false,
  });
}
